import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Icon, Button, Tooltip, Popconfirm } from 'antd'
import './download-progress-notification.css'
import { updateDownload, cancelAllDownload, startDownload, retryDownload } from '../../actions/DownloadAction'
import Socket from '../../utils/sockets'
import { uuidv4 } from '../../utils/index'

export class DownloadProgressNotification extends Component {

  constructor(props) {
    super(props)
    this.state = {
      isCollapsed: true,
      allFail: false,
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.dataDownload !== this.props.dataDownload) {
      if (this.props.dataDownload.filter(f => f.state === 'error').length === this.props.dataDownload.length) {
        this.setState({ allFail: true })
      }
    }
  }
  /**
   * 
   */
  handleCollapsed = val => {
    this.setState({ isCollapsed: val })
  }
  /**
   * 
   */
  handleToggleNotify = () => {
    const { isCollapsed } = this.state
    this.setState({ isCollapsed: !isCollapsed })
  }
  /**
   * 
   */
  handleCancelDownload = uuid => {
    this.props.updateDownload(uuid, 'success')
  }
  /**
   * 
   */
  handleRetryDownload = download => {
    const { client, id, uuid, quality, name } = download
    const newUuid = uuidv4()

    this.setState({ allFail: false })

    this.props.retryDownload(uuid, {
      id,
      uuid: newUuid,
      name,
      state: 'download_in_progress',
      client,
      quality,
    })

    Socket.getInstance().emit('request_client_download', {
      wc: client,
      quality,
      asset: id,
      uuid: newUuid,
    })
  }

  render() {
    const { intl, dataDownload } = this.props
    const { isCollapsed, allFail } = this.state
    const expandedStyle = { right: 0, top: 60, bottom: 'auto' }
    const contractedStyle = { right: 0, top: 60, bottom: 'auto', width: '100px' }

    return (
      <React.Fragment>
        <div className="ant-notification ant-notification-topRight" style={isCollapsed ? expandedStyle : contractedStyle}>
          <span>
            <div className="ant-notification-notice ant-notification-notice-closable">
              {/* Contraido */}
              {!isCollapsed && <div className="nt-head">
                <div style={{ display: 'inline', marginLeft: 5 }}>
                  <Tooltip
                    placement="top"
                    title={intl.formatMessage({ id: 'preparing_download' })}
                    overlayStyle={{ fontSize: '10px' }}>
                    <Icon type="loading" spin style={{ color: '#1890ff', fontSize: 'initial' }} />
                  </Tooltip>
                </div>
                <Tooltip
                  placement="top"
                  title={intl.formatMessage({ id: 'show' })}
                  overlayStyle={{ fontSize: '10px' }}>
                  <Icon type="left" onClick={this.handleToggleNotify} style={{ fontSize: '15px' }} />
                </Tooltip>
              </div>}
              {/* Expandido */}
              {isCollapsed && <div className="ant-notification-notice-content">
                <div className="nt-head">
                  <span style={{ fontSize: '18px' }}>{intl.formatMessage({ id: 'download_state' })}</span>
                  <div style={{ display: 'inline', marginLeft: 5 }}>
                    <Tooltip
                      placement="top"
                      title={intl.formatMessage({ id: 'preparing_download' })}
                      overlayStyle={{ fontSize: '10px' }}>
                      <Icon type="loading" spin style={{ color: '#1890ff', fontSize: 'initial' }} />
                    </Tooltip>
                  </div>
                  <span>
                    <Popconfirm
                      placement="bottom"
                      title={intl.formatMessage({ id: "cancel_all_downloads" })}
                      onConfirm={this.props.cancelAllDownload}
                      okText={intl.formatMessage({ id: "yes" })}
                      cancelText="No">
                      <Button
                        style={{ marginLeft: '5px' }}
                        onClick={this.handleCancelDownload}
                        size={'small'}>{intl.formatMessage({ id: 'cancel_button' })}</Button>
                    </Popconfirm>
                  </span>
                  <span>
                    <Tooltip
                      placement="top"
                      title={intl.formatMessage({ id: !allFail ? 'hide' : 'close' })}
                      overlayStyle={{ fontSize: '10px' }}>
                      {!allFail && <Icon type="right" onClick={this.handleToggleNotify} style={{ fontSize: '15px' }} />}
                      {allFail && <Icon type="close-circle" onClick={this.props.cancelAllDownload} style={{ fontSize: '15px' }} />}
                    </Tooltip>
                  </span>
                </div>
                <hr style={{ marginBottom: 5, marginTop: 5 }}></hr>
                <table className='nt-table'>
                  <thead>
                    <tr>
                      <th>{intl.formatMessage({ id: 'name' })}</th>
                      <th>{intl.formatMessage({ id: 'clients_status' })}</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataDownload.map((r, k) => <tr key={k} style={{ backgroundColor: k % 2 === 0 ? '#f2f2f2' : '#fffff', color: r.state === 'error' ? 'red' : 'inherit' }}>
                      <td>{r.name.length > 40 ? `${r.name.substring(0, 37)}...` : r.name}</td>
                      <td>{intl.formatMessage({ id: r.state === 'error' ? 'error_title' : r.state })}</td>
                      <td>
                        <Tooltip
                          placement="top"
                          title={intl.formatMessage({ id: 'cancel_button' })}
                          onClick={() => this.handleCancelDownload(r.uuid)}
                          overlayStyle={{ fontSize: '10px' }}>
                          <Icon type="close-circle" style={{ fontSize: '12px' }} />
                        </Tooltip>
                        {r.state === 'error' && <Tooltip
                          placement="top"
                          title={intl.formatMessage({ id: 'retry' })}
                          onClick={() => this.handleRetryDownload(r)}
                          overlayStyle={{ fontSize: '10px' }}>
                          <Icon type="redo" style={{ fontSize: '12px', marginLeft: '6px' }} />
                        </Tooltip>}
                        {r.state === 'download_in_progress' && <Tooltip
                          placement="top"
                          title={intl.formatMessage({ id: 'preparing_download' })}
                          overlayStyle={{ fontSize: '10px' }}>
                          <Icon type="loading" spin style={{ color: '#1890ff', fontSize: '12px', marginLeft: '6px' }} />
                        </Tooltip>}
                      </td>
                    </tr>)}
                  </tbody>
                </table>
              </div>}
            </div>
          </span>
        </div >
      </React.Fragment >
    )
  }
}

const mapStateToProps = state => {
  return {
    dataDownload: state.downloads.data,
    workclient: state.client.workclient,
  }
}

const mapDispatchToProps = {
  updateDownload,
  cancelAllDownload,
  startDownload,
  retryDownload,
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(DownloadProgressNotification)))




